import { useEffect, useState } from 'react';

export const useIsKeyHeld = (keyName: string) => {
    const [isShiftDown, setIsShiftDown] = useState(false);

    function downHandler({ key }) {
        if (key === keyName) {
            setIsShiftDown(true);
        }
    }

    function upHandler({ key }) {
        if (key === keyName) {
            setIsShiftDown(false);
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);
        return () => {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    }, [keyName]);

    return [isShiftDown];
};
